'use strict';

const contact = [
  '$http',
  'modal',
  'utils',

  function ($http, modal, utils) {
    return {
      sendMessage: function (postData) {
        return $http.post(utils.getApiUrlV2('support'), postData);
      },

      showModal: function () {
        modal.open({
          template: '<sa-contact-form done="close()"></sa-contact-form>'
        });
      }
    };
  }
];

export default contact;



// WEBPACK FOOTER //
// ./app/src/services/contact.js